import isEmpty from 'lodash/isEmpty';
import trim from 'lodash/trim';

const mergeErrors = (errors, emptyAsNull = false) => {
  var messages = [];
  if (typeof errors === "string") {
    messages.push(errors);
  } else {
    for (var key in errors) {
      var message = errors[key];
      if (!isEmpty(message)) {
        messages.push(message);
      }
    }
  }

  var joinedMessages = messages.join(", ");
  joinedMessages = trim(joinedMessages);
  var joinedMessagesLength = joinedMessages.length - 1;
  if (joinedMessages[joinedMessagesLength] === ",") {
    joinedMessages = joinedMessages.substring(0, joinedMessagesLength);
  }

  if (isEmpty(joinedMessages) && emptyAsNull) {
    return null;
  } else {
    return joinedMessages;
  }
};

export default mergeErrors;
